const state = {
  nav: [
    {
      label: "Users & Permissions",
      feature: "user_management",
      subnav: [
        {
          label: "Users",
          route: "Users",
          view: "users",
        },
        {
          label: "Permissions",
          route: "Permissions",
          view: "permissions"
        },
        // NOT READY YET, NEED ENDPOINT
        // {
        //   label: "User Log",
        //   route: "user_log",
        // },
      ]
    },
    {
      label: "Asset",
      feature: "asset",
      subnav: [
        {
          label: "Categories",
          route: "Asset/categories",
          view: "categories",
  
        },
        {
          label: "Models",
          route: "Asset/models",
          view: "models",
  
        },
      ]
    },
    {
      label: "Chemical",
      feature: "chemical",
      internal: true,
      subnav: [
        {
          label: "Chemical Groups",
          route: "Chemical/Chemical_Groups",
          internal: true,
          view: "chemical",
        }
      ]
    },
    {
      label: "Inventory",
      feature: "inventory",
      subnav: [
        {
          label: "Categories",
          route: "Inventory/categories",
          view: "categories",
        }
      ]
    },
    {
      label: "Thresholds",
      feature: "thresholds",
      subnav: [
        {
          label: "Chemical",
          route: "Thresholds/chemical",
          view: "chemical",
          sidewayDisplay: "Chemical Thresholds"
        },
      ]
    },
    {
      label: "Locations",
      feature: "locations",
      route: "Locations"
    },
    {
      label: "Manufacturers",
      feature: "manufacturers",
      route: "Manufacturers"
    },
    {
      label: "Tenant",
      subnav: [
        {
          label: "Regions",
          route: "Tenant/Regions",
          feature: "regions",
        },
        {
          label: "Unit Of Measure",
          feature: "unit_of_measure",
          route: "Tenant/UnitOfMeasure",
          sidewayDisplay: "Unit Of Measure"
        }
      ]
    },
    {
      label: "Vendors",
      feature: "vendors",
      route: "Vendors"
    },
  ]
};
const getters = {
  configurationNav: state => state.nav
};

export default {
  state,
  getters
};